/**
 * src/connects/group-delete-panel.js
 */

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { emitAlertMessage } from '../actions/alert-message'

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    deleteGroup: ()=> {
      ownProps.onCloseDialog && ownProps.onCloseDialog()
      dispatch(actions.deleteGroup(ownProps.group.group_id))
      dispatch(emitAlertMessage({ message: 'label:ごみ箱に移動トースト', name: ownProps.group.name }, 'success'))
    },
  }
}

export default combineHOC(
  connect(undefined, mapDispatchToProps),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/group-delete-panel.js